module.exports = __webpack_public_path__ + "img/baocao.9fd8f102.svg";